export namespace EinlasskontrolleEntityTypes {
    export const ROLLE_ENTITY = 'EINLASS.ROLLE';
    export const PROTOKOLL_ENTITY = 'EINLASSK.PROTOKOLL';
    export const STATISTIK_ENTITY = 'EINLASSK.STATISTIK';
    
}

